import { AuthConfig } from 'angular-oauth2-oidc';

export const oauthConfig: AuthConfig = {

  // Authorization Server Issuer URL
  issuer: 'https://uat.id.eurofins.com', 
  redirectUri: 'https://dev-reviewcenter.dev-alm.eurofins.com/',
  clientId: 'ReviewCenterApp_Dev',
  strictDiscoveryDocumentValidation: true,
  responseType: 'code',
  scope: 'openid profile',
  oidc: true,
  requestAccessToken: true,
  disablePKCE: false,
  showDebugInformation: true
};
